module.exports = __webpack_public_path__ + "static/media/pedestrian.37208070.svg";